import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	notifications: [],
	errorMessage: null,
	currentNotification: {},
};

export default function notificationsReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_NOTIFICATIONS_SUCCESS:
			return Object.assign({}, state, {
				notifications: action.notifications,
			});
		case ActionTypes.LOAD_NOTIFICATIONS_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case ActionTypes.SELECT_NOTIFICATION_SUCCESS:
			return Object.assign({}, state, {
				currentNotification: action.notification,
			});
		case ActionTypes.RESET_CURRENT_NOTIFICATION:
			return Object.assign({}, state, {
				currentNotification: {},
			});
		default:
			return state;
	}
}
